var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_vm._v("\n  北京运多多网络科技有限公司创始于2015年7月，联合创始人均来自阿里巴巴、360公司、百度、摇篮网和SYNNEX等知名公司。\n  公司致力于科技、互联网传统相关业务模式，基于互联网思维，为B、C端用户提供服务，旗下产品有京东区域营销、洗爱车、天天向上等知名产品。目前深度合作了京东、阳光海天全国最大洗车服务平台、易车生活、博众博悦等精准的战略伙伴与资源。\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdaea060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/children/aboutme.vue
// module id = null
// module chunks = 